import { VariableWidthContainer } from './Styles'
import useSubMenuStore from '@/stores/useSubMenuStore'
import { ReactNode } from 'react'

interface ContentWithSubMenuProps {
  children?: ReactNode
  basic?: boolean
  noPadding?: boolean
  noMinHeight?: boolean
  allowOverflow?: boolean
}

const ContentWithSubMenu = ({
  children,
  basic,
  noPadding,
  noMinHeight,
  allowOverflow,
  ...rest
}: ContentWithSubMenuProps) => {
  const expanded = useSubMenuStore(state => state.expanded)

  return (
    <VariableWidthContainer
      expanded={expanded}
      noPadding={noPadding}
      noMinHeight={noMinHeight}
      allowOverflow={allowOverflow}
      basic={basic}
      {...rest}>
      {children}
    </VariableWidthContainer>
  )
}

export default ContentWithSubMenu
